import React, { useEffect } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import Footer from "../../redesign/components/Footer";
import ManageServicesTabContent from "./ManageServicesTabContent";
import ManageProfileTabContent from "./ManageProfileTabContent";
// import "./ServiceProviderDashboard.css";
import Navbar from "../../redesign/components/Navbar";
import styles from "./ServiceProviderDashboard.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getServiceProviderBusinessDetails,
  getServiceProviderProfile,
} from "../../Apiservices/Auth/servers/profileServer";
import {
  setBusinessData,
  setProfileData,
} from "../../store/providerProfileSlice";

const ServiceProviderDashboard = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    console.log("Use effect iscalled");
    const fetchDataIfNeeded = async () => {
      try {
        const profile = await getServiceProviderProfile();
        dispatch(setProfileData(profile));
      } catch (err) {
        console.error("Error setting profile data", err);
      }

      try {
        const business = await getServiceProviderBusinessDetails();
        dispatch(setBusinessData(business));
      } catch (err) {
        console.error("Error setting business data", err);
      }
    };

    fetchDataIfNeeded();
  }, [dispatch]);

  return (
    <div className={styles.dashboardWrapper}>
      <Navbar />
      <main className={styles.mainContent}>
        <div className={styles.thCustomTabWrapper}>
          <TabView>
            <TabPanel header={`Manage Services`}>
              <ManageServicesTabContent />
            </TabPanel>

            <TabPanel header="Manage Orders">
              <div sx={{ p: 2 }}>Manage Orders</div>
            </TabPanel>

            <TabPanel header="My Account">
              <ManageProfileTabContent />
            </TabPanel>
          </TabView>
        </div>
      </main>
      <Footer></Footer>
    </div>
  );
};

export default ServiceProviderDashboard;
